import { snakeToCamelMap } from '@repo/utils'
import {
  editAssortmentHeaders,
  editMaterialsSequencesHeaders,
  launchesAddErpHeaders,
  launchesAddMaterialsHeaders,
  launchesDeleteErpHeaders,
  launchesDeleteMaterialsHeaders,
  replaceMaterialsAssortmentHeaders,
  replaceMaterialsLaunchesHeaders,
} from './schema'

export const REPLACE_MATERIALS_ASSORTMENTS_CAMEL_KEYS = Object.values(
  snakeToCamelMap(replaceMaterialsAssortmentHeaders),
)

export const REPLACE_MATERIALS_LAUNCHES_CAMEL_KEYS = Object.values(
  snakeToCamelMap(replaceMaterialsLaunchesHeaders),
)

export const EDIT_ASSORTMENTS_CAMEL_KEYS = Object.values(snakeToCamelMap(editAssortmentHeaders))

export const ADD_LAUNCH_MATERIALS_CAMEL_KEYS = Object.values(
  snakeToCamelMap(launchesAddMaterialsHeaders),
)
export const ADD_LAUNCH_ERPS_CAMEL_KEYS = Object.values(snakeToCamelMap(launchesAddErpHeaders))

export const DELETE_LAUNCH_MATERIALS_CAMEL_KEYS = Object.values(
  snakeToCamelMap(launchesDeleteMaterialsHeaders),
)

export const DELETE_LAUNCH_ERPS_CAMEL_KEYS = Object.values(
  snakeToCamelMap(launchesDeleteErpHeaders),
)

export const EDIT_MATERIALS_SEQUENCES_CAMEL_KEYS = Object.values(
  snakeToCamelMap(editMaterialsSequencesHeaders),
)
